import { useEffect, useState } from "react";
import { ArrowRight, CheckCircle2, ListTodo } from "lucide-react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

export const NeedsYouPanel = ({ user }) => {
  const [data, setData] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let active = true;
    api.get("/dashboard/needs-you").then((r) => active && setData(r.data)).catch(() => active && setFailed(true));
    return () => { active = false; };
  }, []);

  if (failed || (data && !data.checked?.length)) return null;
  return (
    <section className="needs-you-panel" data-testid="needs-you-panel" aria-busy={!data}>
      <div className="needs-you-head">
        <ListTodo size={16} />
        <div>
          <p className="eyebrow">NEEDS YOU</p>
          <h2>{user?.first_name ? `${user.first_name}, here is what is waiting on you` : "What is waiting on you"}</h2>
        </div>
        {data && <small className="needs-you-stamp" data-testid="needs-you-stamp">Counted {new Date().toLocaleTimeString([], { hour: "numeric", minute: "2-digit" })}</small>}
      </div>
      {!data && <p className="needs-you-empty">Counting…</p>}
      {data && !data.rows.length && <p className="needs-you-empty" data-testid="needs-you-empty"><CheckCircle2 size={14} /> Nothing needs you right now.</p>}
      {data && data.rows.length > 0 && (
        <ul className="needs-you-list">
          {data.rows.map((row) => (
            <li key={row.key} data-testid={`needs-you-row-${row.key}`}>
              <Link to={row.href} className="needs-you-link" data-testid={`needs-you-link-${row.key}`}>
                <strong className="needs-you-count" data-testid={`needs-you-count-${row.key}`}>{row.count}</strong>
                <span className="needs-you-label">{row.label}{row.hint ? <small>{row.hint}</small> : null}</span>
                <ArrowRight size={14} />
              </Link>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
};
